<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 13:38:11
 * @FilePath: \mrc-ess-fronted\src\Layout\components\SlideRight.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-16 17:58:42
-->
<template>
  <v-navigation-drawer
    v-if="!hidden && $vuetify.breakpoint.name != 'xs'"
    v-model="drawer"
    clipped
    transition
    width="340"
    right
    app
    absolute
  >
    <v-date-picker
      v-model="picker"
      color="primary"
      :locale="defaultLang"
      :day-format="
        (date) => {
          return $getDateTime(date, 'D');
        }
      "
      full-width
      no-title
      :show-current="false"
      :events="curEvents"
      :event-color="'red'"
    >
    </v-date-picker>
    <div
      :style="{
        height: $vuetify.breakpoint.height - 56 - 290 + 'px',
        overflow: 'overlay',
      }"
      class="py-2 text-center"
    >
      <v-divider></v-divider>

      <!-- <v-btn color="primary" rounded>{{ curPicker }}</v-btn> -->
      <TimeLine :curDate="picker" />
      <!-- <v-btn color="grey lighten-3" rounded @click.stop="toPicker">{{
        nextPicker
      }}</v-btn> -->
    </div>
  </v-navigation-drawer>
</template>
<script>
import dayjs from "dayjs";
import { mapGetters } from "vuex";
export default {
  name: "SlideRight",
  computed: {
    ...mapGetters(["defaultLang"]),
    drawer: {
      get() {
        return this.stretch;
      },
      set(val) {
        return val;
      },
    },
    curPicker() {
      return dayjs(this.picker).format("YYYY/MM/DD");
    },
    nextPicker() {
      return dayjs(this.picker).add(1, "day").format("YYYY/MM/DD");
    },
  },
  props: {
    hidden: { default: false, type: Boolean },
    stretch: { default: false, type: Boolean },
  },
  watch: {
    $route(route) {
      if (route.path === "/dashboard")
        this.picker = dayjs(new Date()).format("YYYY-MM-DD");
    },
  },
  data() {
    return { picker: "", desserts: [] };
  },
  mounted() {
    this.picker = dayjs(new Date()).format("YYYY-MM-DD");
    // 获取是否请假
    // this.getEvent(
    //   this.$getTimeValue(dayjs().startOf("month").format("YYYY-MM-DD")),
    //   this.$getTimeValue(dayjs().endOf("month").format("YYYY-MM-DD"))
    // );
  },
  methods: {
    toPicker() {
      this.picker = dayjs(this.nextPicker).format("YYYY-MM-DD");
    },
    onStretch: function () {
      this.$emit("onStretch", false);
    },
    curEvents(date) {
      if (this.desserts.length <= 0) return false;
      let curDate = this.desserts.find(
        (ele) =>
          dayjs(date).format("YYYY-MM-DD") ===
          dayjs(ele.date).format("YYYY-MM-DD")
      );
      if (!curDate) return false;
      if (curDate["items"].length <= 0) return false;
      if (curDate["items"].length == 1) return true;
      if (curDate["items"].length > 1) {
        let arr = [];
        curDate["items"].map((item, index) => {
          if (index < 3)
            //最多显示3个
            arr.push(
              // this.$avatarColors[
              //   Math.floor(Math.random() * Math.floor(this.$avatarColors.length - 1))
              // ]
              "red"
            );
        });
        return arr;
      }
    },
    getEvent: function (start, end) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess",
        url: "/approval/get-calendar-tasks/",
        data: {
          start_utc_datetime: start,
          end_utc_datetime: end,
        },
        type: "client",
        notAlert: true,
      }).then((res) => {
        that.desserts = res.data ? res.data.calendar : [];
      });
    },
  },
};
</script>
<style scoped>
</style>